import { Controller } from "@hotwired/stimulus";
import tinymce from "tinymce";

export default class extends Controller {
  static targets = ["editor"];

  connect() {
    // Listen for the event on multiple potential targets
    this.element.addEventListener('tinymce:ready', () => {
      console.log('tinymce:ready event on element triggered');
      this.onEditorReady();
    });
  }

  onEditorReady() {
    console.log('TinyMCE editor ready event received');
    // Load default template once TinyMCE is ready
    const selectElement = this.element.querySelector('select[data-action*="template-editor#loadTemplate"]');
    console.log('Select element found:', selectElement);
    console.log('Select element value:', selectElement?.value);
    console.log('Select element baseUrl:', selectElement?.dataset.baseUrl);
    const editor = tinymce.get(this.editorTarget.id);
    if (selectElement && selectElement.value && editor && editor.getContent() === '') {
      console.log('Loading template with value:', selectElement.value);
      this.loadTemplateByValue(selectElement.value, selectElement.dataset.baseUrl);
    }
  }

  loadTemplate(event) {
    const selectedTemplate = event.target.value; // Get the selected template value
    const baseUrl = event.target.dataset.baseUrl; // Fetch the base URL from data attribute
    this.loadTemplateByValue(selectedTemplate, baseUrl);
  }

  loadTemplateByValue(templateValue, baseUrl) {
    const url = `${baseUrl}?template=${templateValue}`; // Construct the full URL

    // Fetch the template content
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((content) => {
        this.updateEditor(content); // Populate TinyMCE editor
      })
      .catch((error) => {
        console.error("Failed to load template:", error);
      });
  }

  updateEditor(content) {
    const editor = tinymce.get(this.editorTarget.id);
    if (editor) {
      editor.setContent(content); // Update the TinyMCE content
    } else {
      console.error("TinyMCE editor not found");
    }
  }
}
